import React, { useState, useCallback, useEffect, useRef } from 'react';
// import { StaticImage } from 'gatsby-plugin-image';

import Select from 'react-select';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import {
  CustomRadio,
  CustomUploadFile,
  Dropdown,
  PersonDetail,
} from '../styles/elements';
import { WhiteBlock } from '../styles/WhiteBlock';
const accessDetail = [
  { value: 'Editor', label: 'Editor' },
  { value: 'Viewer', label: 'Viewer' },
];
const SetupWorkspace = () => {
  const [setupStep, setSetupStep] = useState(0);
  const setupStepclick = useCallback((value) => (e) => {
    if (e) e.preventDefault();
    setSetupStep((state) => (state === value ? null : value));
  });

  const PersonList = useRef();

  useEffect(() => {
    if (PersonList.current.childNodes.length > 3) {
      PersonList.current.classList.add('overflow-auto');
    }
  }, []);

  return (
    <Layout>
      <SEO title="Home" />
      <div className="db-area-main">
        <div className="db-container">
          <a href="#!" className="db-back-link button-chevron-left">
            <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
            dashboard
          </a>

          <h1 className="db-heading text-center">Setup Your Workspace</h1>

          <WhiteBlock style={{ maxWidth: 490, margin: '0 auto' }}>
            <div className="setup-step-count">
              <div
                className={`single-count ${
                  setupStep === 0 ? ' active' : 'completed'
                } `}>
                <span>1</span>
                <p>Name Workspace</p>
              </div>
              <div
                className={`single-count ${setupStep === 1 ? ' active' : ''} ${
                  setupStep === 2 ? ' completed' : ' '
                }`}>
                <span>2</span>
                <p>Add Members</p>
              </div>
              <div
                className={`single-count ${setupStep === 2 ? ' active' : ''}`}>
                <span>3</span>
                <p>Payments</p>
              </div>
            </div>

            <div className="create-team-steps">
              <div
                className="single-step"
                style={{
                  transform: `${
                    setupStep === 0 ? ' translateX(0%)' : 'translateX(-100%)'
                  }`,
                }}>
                <CustomUploadFile>
                  <div className="flex-row no-margin upload-file-input align-items-center">
                    <div className="img-placeholder">
                      <img src="/img/image-placeholder.svg" alt="logo" />
                    </div>
                    <div className="flex-1">
                      <p style={{ marginBottom: 12 }}>
                        JPG or PNG Max size of 800k
                      </p>

                      <div className="flex-row no-margin position-relative">
                        <div className="position-relative">
                          <input
                            type="file"
                            className="custom-file-upload-button"
                          />
                          <span className="button light-blue-button">
                            Add Picture
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </CustomUploadFile>
                <div style={{ marginBottom: 25 }}>
                  <label>Workspace Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Workspace Name"
                  />
                </div>
                <div style={{ marginBottom: 25 }}>
                  <label>Industry</label>
                  <select className="form-control">
                    <option value="">Media and Entertainment</option>
                    <option value="">Design</option>
                  </select>
                </div>

                <div className="text-right step-button-block">
                  <button
                    className="button"
                    onClick={setupStepclick(1)}
                    type="button">
                    Continue
                  </button>
                </div>
              </div>

              <div
                className="single-step"
                style={{
                  transform: `${
                    setupStep === 1 ? ' translateX(-100%)' : 'translateX(0%)'
                  } ${
                    setupStep === 2 ? ' translateX(-200%)' : 'translateX(0%)'
                  }`,
                }}>
                <div
                  className="member-invite-main"
                  style={{ marginBottom: 30 }}>
                  <div className="member-invite-input">
                    <input type="text" placeholder="Enter member email..." />
                    <Select
                      defaultValue={accessDetail[0]}
                      className="member-access-select"
                      options={accessDetail}
                    />
                  </div>
                  <div className="member-invite-button text-center">
                    <button
                      type="submit"
                      className="button"
                      style={{ minWidth: 95 }}>
                      Invite
                    </button>
                  </div>
                </div>

                <p className="font-16 weight-500">Pending</p>

                <div
                  className="member-list-main steps-member-list"
                  ref={PersonList}>
                  <div className="flex-row align-items-center single-member-line">
                    <div className="col flex-1">
                      <PersonDetail>
                        <div className="round-image">
                          <img src="/img/person-1.jpg" alt="" />
                        </div>
                        <div>
                          <h3>Vennis John</h3>
                          <p>veninsjhon1@gmail.com</p>
                        </div>
                      </PersonDetail>
                    </div>

                    <div className="col flex-1">
                      <Select
                        defaultValue={accessDetail[0]}
                        className="custom-select"
                        options={accessDetail}
                      />
                    </div>
                    <div className="col flex-1">
                      <Dropdown>
                        <span className="dropdown-dots">
                          <span></span>
                        </span>

                        <ul className="dropdown-menu">
                          <li>
                            <a href="#!">
                              <img src="/img/edit.svg" alt="" /> Edit
                            </a>
                          </li>
                          <li>
                            <a href="#!" className="red">
                              <img src="/img/bin.svg" alt="" /> Delete
                            </a>
                          </li>
                        </ul>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="flex-row align-items-center single-member-line">
                    <div className="col flex-1">
                      <PersonDetail>
                        <div className="round-image">
                          <img src="/img/person-1.jpg" alt="" />
                        </div>
                        <div>
                          <h3>Vennis John</h3>
                          <p>veninsjhon1@gmail.com</p>
                        </div>
                      </PersonDetail>
                    </div>

                    <div className="col flex-1">
                      <Select
                        defaultValue={accessDetail[0]}
                        className="custom-select"
                        options={accessDetail}
                      />
                    </div>
                    <div className="col flex-1">
                      <Dropdown>
                        <span className="dropdown-dots">
                          <span></span>
                        </span>

                        <ul className="dropdown-menu">
                          <li>
                            <a href="#!">
                              <img src="/img/edit.svg" alt="" /> Edit
                            </a>
                          </li>
                          <li>
                            <a href="#!" className="red">
                              <img src="/img/bin.svg" alt="" /> Delete
                            </a>
                          </li>
                        </ul>
                      </Dropdown>
                    </div>
                  </div>
                </div>

                <div className="flex-row justify-space-between no-margin step-button-block">
                  <button
                    className="button light-blue-button"
                    type="button"
                    onClick={setupStepclick(0)}>
                    Back
                  </button>
                  <button
                    className="button"
                    type="button"
                    onClick={setupStepclick(2)}>
                    Continue
                  </button>
                </div>
              </div>
              <div
                className="single-step"
                style={{
                  transform: `${
                    setupStep === 1 ? ' translateX(-100%)' : 'translateX(0%)'
                  } ${
                    setupStep === 2 ? ' translateX(-200%)' : 'translateX(0%)'
                  }`,
                }}>
                <div className="flex-row">
                  <div className="col flex-1">
                    <CustomRadio>
                      <input
                        type="radio"
                        name="billing-time"
                        id="monthly"
                        checked
                      />
                      <label htmlFor="monthly">Billed monthly</label>
                    </CustomRadio>
                  </div>
                  <div className="col flex-1">
                    <CustomRadio>
                      <input type="radio" name="billing-time" id="annually" />
                      <label htmlFor="annually">Billed annually</label>
                    </CustomRadio>
                  </div>
                </div>

                <table className="table billing-table">
                  <thead>
                    <tr>
                      <th style={{ width: '70%' }}>Payment details</th>
                      <th>Setup Billing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Teams
                        <br />
                        <Dropdown
                          className="tooltip-dropdown"
                          style={{ paddingBottom: 5 }}>
                          <a href="#!" className="link-unstyled">
                            Plan Details
                          </a>

                          <div className="dropdown-menu" style={{ left: 20 }}>
                            <ul className="check-list">
                              <li>Unlimited Stories</li>
                              <li>Featured MS Editor</li>
                              <li>Page Attachment</li>
                              <li>Google analytics integration</li>
                              <li>Story Sharing</li>
                            </ul>

                            <div className="text-center">
                              <a href="#!" className="link-unstyled">
                                View all features
                              </a>
                            </div>
                          </div>
                        </Dropdown>
                      </td>
                      <td className="blue weight-600">$149</td>
                    </tr>
                    <tr>
                      <td>Additional user</td>
                      <td className="weight-600">
                        $85 <span className="weight-500">(3 users)</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Total monthly cost</td>
                      <td className="weight-600">$234</td>
                    </tr>
                  </tbody>
                </table>

                <div className="flex-row justify-space-between no-margin step-button-block">
                  <button
                    className="button light-blue-button"
                    type="button"
                    onClick={setupStepclick(1)}>
                    Back
                  </button>
                  <button className="button" type="button">
                    Make Payment
                  </button>
                </div>
              </div>
            </div>
          </WhiteBlock>
        </div>
      </div>
    </Layout>
  );
};
export default SetupWorkspace;
